
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface PublicProfile {
  id: string;
  username: string;
  profile_picture: string | null;
  avatar_url: string | null;
  is_private: boolean;
  created_at: string;
}

export const usePublicProfile = (username?: string) => {
  const [profile, setProfile] = useState<PublicProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!username) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('id, username, profile_picture, avatar_url, is_private, created_at')
          .eq('username', username)
          .single();

        if (error) {
          if (error.code === 'PGRST116') {
            setError('User not found');
          } else {
            throw error;
          }
        } else {
          setProfile(data);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        setError('Failed to load profile');
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [username]);

  return {
    profile,
    isLoading,
    error
  };
};
